import { Option } from 'funfix-core';
import { List } from 'immutable';
export const nonEmptyList = l => l.isEmpty() ? Option.empty() : Option.some(l);
export const singletonNonEmptyList = e => List([e]);
export const headOfNonEmptyList = l => Option.of(l.get(0)).getOrElseL(() => {
  throw new Error("Illegal state - shouldn't have a NonEmptyList without an item");
});